module.exports = __webpack_public_path__ + "img/afar.2f9e1d6a.svg";